var TECL_SeriesOrderForm = {

  // Open or close the selected panel
  TogglePanel: function(headerId, bodyId) {
    var $headerPanel = $("#" + headerId);
    var $bodyPanel = $("#" + bodyId);

    if ($headerPanel, $bodyPanel) {
      var expanded = $bodyPanel.hasClass("in");
      var $arrowIndicator = $headerPanel.find(".openStateIndicator");

      if ($arrowIndicator) {
        if (expanded) {
          $bodyPanel.collapse("hide");
          $arrowIndicator.removeClass("glyphicon-chevron-up");
          $arrowIndicator.addClass("glyphicon-chevron-down");
        } else {
          $bodyPanel.collapse("show");
          $arrowIndicator.removeClass("glyphicon-chevron-down");
          $arrowIndicator.addClass("glyphicon-chevron-up");
        }
      }
    }
  },

  // Update the product's total
  UpdateProductTotal: function(rowId) {
    var $productRow = $("#" + rowId);

    if ($productRow) {
      var $quantityInput = $productRow.find("[name=quantityColInput]");

      if ($quantityInput) {
        var quantity = $quantityInput.val();
        var price = $productRow.attr("data-price");
        var value = 0;

        if (price && price > 0 && quantity && quantity > 0) {
          value += (price * quantity);
        }

        var $outterTotal = $productRow.find(".totalCol");

        if ($outterTotal) {
          var $innerTotal = $outterTotal.find(".productInfo");

          if ($innerTotal) {
            $innerTotal.html("&pound;" + value.toFixed(2));

            TECL_SeriesOrderForm.UpdateFinalTotal();
          }
        }
      }
    }
  },

  // Update the final total of all the product totals
  UpdateFinalTotal: function() {
    var datas = TECL_SeriesOrderForm.Serialise();
    var value = 0;

    if (datas && datas.length > 0) {

      datas.forEach(function(productData) {
        var price = productData.PriceExVat;
        var quantity = productData.Quantity;

        if (price && price > 0 && quantity && quantity > 0) {
          value += (price * quantity);
        }
      });
    }

    $("#finalTotalValue").html("&pound;" + value.toFixed(2));
  },

  // Update the final total of all the product totals
  Serialise: function() {
    var datas = [];
    var $productRows = $("[name=productInfoRow]");

    if ($productRows) {
      $productRows.each(function() {
        var $quantityRow = $(this);

        if ($quantityRow) {
          var $quantityInput = $quantityRow.find("[name=quantityColInput]");

          if ($quantityInput) {
            var quantity = $quantityInput.val();

            if (quantity > 0) {
              datas.push({
                ProductId: $quantityRow.attr("data-productId"),
                Title: $quantityRow.attr("data-title"),
                ISBN: $quantityRow.attr("data-isbn"),
                PriceExVat: $quantityRow.attr("data-price"),
                Quantity: quantity
              }
              );
            }
          }
        }
      });
    }
    return datas;
  },

  // Add all the items to the basket
  AddToBasket: function() {
    $("#saveError").addClass("hidden");
    var datas = TECL_SeriesOrderForm.Serialise();

    if (datas && datas.length > 0) {

      TECL_CheckoutGeneral.TogglePleaseWait(true);

      // Save and redirect or show error message text
      $.ajax({
        url: "/umbraco/Surface/BasketSurface/AddMultipleItems",
        type: "POST",
        data: {
          saveItems: datas
        },
        error: function() {
          TECL_CheckoutGeneral.TogglePleaseWait(false);
          $("#saveError").removeClass("hidden");
        },
        success: function(data) {
          TECL_CheckoutGeneral.TogglePleaseWait(false);

          if (data) {
            // Redirect to the basket page
            window.location.href = "/basket";
          } else {
            $("#saveError").removeClass("hidden");
          }
        }
      });
    }
  }

};
